// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"clickToCopyWrapper_wrapper__veZHW"};